import * as React from 'react';
import { HeroNotFound } from '@balance-web/illustration';

import { ErrorScreen } from '../../components/app/ErrorScreen';
import { Config } from '../Config';

import { CompanyIdContext } from './CompanyContext';
export type CompanyIdProviderProps = {
  companyId?: string;
  children: React.ReactNode;
};

export const CompanyIdProvider = ({
  children,
  companyId,
}: CompanyIdProviderProps) => {
  if (!companyId && !!Config.APPLICATION_FEATUREFLAG_FAKECHECKOUTLAUNCHER) {
    return <>{children}</>;
  } else if (!companyId) {
    return (
      <ErrorScreen
        image={<HeroNotFound />}
        refreshButtonLabel="Return to Reckon Portal Dashboard"
        title="Oops!"
        onRefreshClick={() => {
          window.location.href = Config.APPLICATION_PORTAL_LOGIN_URL;
        }}
      >
        A company id is required.
      </ErrorScreen>
    );
  } else {
    return (
      <CompanyIdContext.Provider value={{ id: companyId }}>
        {children}
      </CompanyIdContext.Provider>
    );
  }
};
